import { translateDate } from "../../services/Helpers/TranslationHelpers";
import { Button, Icon, TooltipProps } from "imaginarity-react-ui";
import { createNamedRoute } from "../../services/Helpers/RoutingHelper";
import LoadingDataTable from "../../components/LoadingDataTable/LoadingDataTable";
import * as React from "react";
import { SessionDownloadDto } from "collaboration-service";
import { useImgI18N } from "../../services/ImgI18N";

export interface SessionsEnrollmentTableProps {
    sessions: SessionDownloadDto[];
    linkTarget: "_blank" | "_self" | "_parent" | "_top" | undefined;
    tooltip?: Omit<TooltipProps, "children"> | undefined;
}

const SessionsEnrollmentTable = (p: SessionsEnrollmentTableProps) => {
    const { sessions, linkTarget, tooltip } = p;

    const { t } = useImgI18N("sessionManagement");

    return <LoadingDataTable loadData={sessions} loaderData={{}} noFilter hideMoreLessEnties columns={[
        {
            elementName: "headlines",
            columnCreator: "lngString",
            absWidth: 400
        },
        {
            elementName: "status",
            absWidth: 60
        },
        {
            elementName: "parts",
            absWidth: 100,
            header: () => <span>{t("begin")}</span>,
            cell: ctx => {
                return (
                    <>
                        {ctx.row.original.parts && ctx.row.original.parts.length > 0 &&
                            <span>{translateDate(ctx.row.original.parts[0].begin, "P")}</span>
                        }
                    </>
                )
            }
        },
        {
            elementName: "id",
            header: () => <Icon name='empty' />,
            absWidth: 100,
            cell: c => {
                return (
                    <Button
                        icon="arrow right"
                        content={t("enroll")}
                        kind="transparentButton"
                        asHtmlLinkToRoute={createNamedRoute("session_enroll_to", { id: c.row.original.id }, true)}
                        asHtmlLinkToRouteTarget={linkTarget}
                        tooltip={tooltip}
                    />
                )
            }
        }
    ]} />;
}

export default SessionsEnrollmentTable;